import {
    useClinic
} from "@/components/Context/ClinicaContext";
import { useUser } from "@/components/Context/UserContext";
import { request } from "@/services/fetch";
import { getNotificacoes } from "@/services/notificationsService";
import {
    Box,
    Button,
    Divider,
    Flex,
    Text,
    useColorModeValue,
    VStack
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import packageInfo from "../../../../package.json";

const isLegacyFilaNotification = (n) => {
    const t = String(n?.title || "")
        .trim()
        .toLowerCase();
    return (
        n?.tipo !== "fila_espera_ativa" &&
        (t === "fila de espera" || t.startsWith("nova fila"))
    );
};


const SidebarROOT = () => {
    const navigate = useNavigate();
    const { selectedClinic } = useClinic();
    const { user, logout } = useUser(); // Get user and clinicasVinculadas from context
    const sidebarBgColor = useColorModeValue("#F7F8FA", "gray.800");
    const textColor = useColorModeValue("teal.800", "teal.200");
    const menuHeaderColor = useColorModeValue("gray.500", "gray.400");
    const selectedClinicIdRef = useRef(selectedClinic?._id);
    selectedClinicIdRef.current = selectedClinic?._id;

    const refreshNotifications = async () => {
        try {
            const cid = selectedClinic?._id;
            if (!cid) return;
            const { naoLidas } = await getNotificacoes(cid, 10);
            const rawUnread = Array.isArray(naoLidas) ? naoLidas : [];
            const filteredUnread = rawUnread.filter(
                (n) => !isLegacyFilaNotification(n),
            );
        } catch (e) {
            // Silencioso: não bloqueia o sidebar caso API falhe
        }
    };

    /** Login grava `user.id` (não `_id`); depender só de `_id` impedia o sino de carregar para colaborador/profissional. */
    const userNotifyKey = user
        ? String(user.id ?? user._id ?? user.user?.id ?? user.user?._id ?? "")
        : "";
    useEffect(() => {
        if (!user || !userNotifyKey) return;
        refreshNotifications();
        const id = setInterval(refreshNotifications, 45000);
        const onVis = () => {
            if (document.visibilityState === "visible") refreshNotifications();
        };
        window.addEventListener("focus", refreshNotifications);
        document.addEventListener("visibilitychange", onVis);
        return () => {
            clearInterval(id);
            window.removeEventListener("focus", refreshNotifications);
            document.removeEventListener("visibilitychange", onVis);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userNotifyKey, selectedClinic?._id]);

    return (
        <Box
            bg={sidebarBgColor}
            color={textColor}
            w="296px"
            py="5"
            borderRight="1px"
            borderColor="gray.200"
        >
            <Box mb="5" px="5">
                <Flex align="center" justify="space-between">
                    <Text fontSize="lg" fontWeight="bold" color={textColor}>
                        OSTEOMEDIC
                    </Text>
                </Flex>
                {user ? (
                    <Text fontSize="md" color={textColor}>
                        Bem-vindo, {user.nomeCompleto || user.name || "Usuário"}
                    </Text>
                ) : (
                    <Text fontSize="md" color={textColor}>
                        Bem-vindo
                    </Text>
                )}

            </Box>
            <Divider />

            <VStack align="stretch" spacing="1">
                <Text
                    px="5"
                    mt="5"
                    mb="2"
                    color={menuHeaderColor}
                    fontSize="sm"
                    fontWeight="semibold"
                >
                    MENU
                </Text>

                <Text
                    px="5"
                    mt="3"
                    mb="1"
                    color={menuHeaderColor}
                    fontSize="xs"
                    fontWeight="semibold"
                >
                    ADMINISTRAÇÃO
                </Text>
                <VStack align="stretch" pl={10}>
                    <Text
                        cursor="pointer"
                        _hover={{ color: "teal.500" }}
                        onClick={() => navigate("/manager/licenca")}
                    >
                        Controle de Licenças
                    </Text>
                </VStack>
                <Box mt="5" px="5">
                    <Button
                        colorScheme="teal"
                        variant="outline"
                        onClick={() => {

                            logout();
                        }}
                    >
                        Logoff
                    </Button>
                    <Text mt={4}>{packageInfo.version} v</Text>
                </Box>
            </VStack>
        </Box>
    );
};

export default SidebarROOT;
